import { useEventInfo } from '@shared/utils/eventInfo';
import { useBestLocationAnchorQuery } from '@graphql/generated';

export const useBestAnchorLocation = ({
  onCompleted,
  skip
}: {
  onCompleted: (data: { latitude: string; longitude: string; friendlyName: string } | null) => void;
  skip: boolean;
}) => {
  const { eventHandle, loading: eventInfoLoading } = useEventInfo();
  const { data, loading, error } = useBestLocationAnchorQuery({
    variables: {
      name: eventHandle || ''
    },
    onCompleted: data => {
      onCompleted(data?.eventByName?.bestLocationAnchor || null);
    },
    batchMode: 'off',
    skip: skip || eventInfoLoading
  });

  return { bestAnchorLocation: data?.eventByName?.bestLocationAnchor, loading, error };
};
